import { aggList, platformFeed } from "@/mocks/kanliao";

export default function AggSection() {
  return (
    <section id="feed" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="font-label text-xs font-semibold uppercase tracking-[0.24em] text-primary-600">
              全网吃瓜汇总
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              同一个瓜，各平台的打开方式
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-secondary-700">
            微博、豆瓣、抖音、小红书、贴吧、B 站……同一条事件的不同切面与最新动向，汇总到一张页面里对照着看。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-[250px_1fr] lg:gap-8">
          {/* platform rail */}
          <aside className="rounded-2xl bg-background-50 p-4 ring-1 ring-background-200">
            <div className="mb-3 flex items-center justify-between px-1">
              <span className="text-sm font-bold text-foreground-950">今日来源热度</span>
              <i className="ri-remixicon-fill text-secondary-400" aria-hidden="true"></i>
            </div>
            <div className="flex flex-col gap-2">
              {platformFeed.map((p) => (
                <div
                  key={p.platform}
                  className="flex items-center justify-between rounded-xl bg-background-100 px-3 py-2.5"
                >
                  <span className="flex items-center gap-2.5 text-sm font-medium text-foreground-900">
                    <span className="grid h-7 w-7 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className={`${p.icon} text-sm`} aria-hidden="true"></i>
                    </span>
                    {p.platform}
                  </span>
                  <span className="font-heading text-sm font-bold text-primary-700">{p.count}</span>
                </div>
              ))}
            </div>
            <p className="mt-3 px-1 text-[11px] leading-relaxed text-secondary-500">
              数量为该来源今日涉瓜条目数，滚动聚合。
            </p>
          </aside>

          {/* aggregated feed */}
          <div className="flex flex-col divide-y divide-background-200 rounded-2xl bg-background-50 ring-1 ring-background-200">
            {aggList.map((item) => (
              <article key={item.id} className="flex flex-col gap-3 p-4 transition-colors hover:bg-background-100/60 md:flex-row md:items-start md:gap-5 md:p-5">
                <span className="inline-flex w-fit shrink-0 items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-800">
                  <i className="ri-radio-button-line text-primary-500" aria-hidden="true"></i>
                  {item.platform}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950 md:text-base">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-secondary-700">{item.summary}</p>
                  <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-secondary-500">
                    <span className="flex items-center gap-1 font-medium text-foreground-700">
                      <i className="ri-at-line" aria-hidden="true"></i>
                      {item.handle}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" aria-hidden="true"></i>
                      {item.time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-community-line" aria-hidden="true"></i>
                      {item.reactions}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}